import  deviceTypes from './devicetypes.json';
import { unifiedValue } from './tuyaUtils';

const tempProps = deviceTypes.wifitemperator.reduce((p, item) => ({ ...p, [item.key]: item }), {});

class TempInfo {
    constructor({ va_temperature: temperature, va_humidity: humidity, battery_percentage: batteryPercentage }) {
        this.temperator = temperature
        this.humidity = humidity
        this.batteryPercentage = batteryPercentage
    }

    getUnifiedTemperature() {
        const tempProp = tempProps.va_temperature;     
        console.log('props', tempProps);
        return unifiedValue(this.temperator, tempProp)
    }

    getTemperature() {       
        const tempProp = tempProps.va_temperature;     
        console.log('props', tempProps);
        return unifiedValue(this.temperator, tempProp) + tempProp.unit
    }

    getHumidity() {       
        const prop = tempProps.va_humidity;     
        return this.humidity * (prop.multiplevalue || 1) + prop.unit
    }

    getBatteryPercentage() {       
        const prop = tempProps.battery_percentage;     
        return this.batteryPercentage * (prop.multiplevalue || 1) + prop.unit
    }
}
export default TempInfo;